import { useClientPortalInternalData } from '../../../hooks/use-client-portal-internal-data'

export const useProcessingTime = () => {
  const { dataClientPortalInternal, navigateToCaseDetail } = useClientPortalInternalData()

  // Data
  const applicationFilingDate = dataClientPortalInternal?.caseInfo?.applicationFiledDate
  const processingTimeData = dataClientPortalInternal?.processingTime
  const { processingTime, inquiryIcon, inquiryText } = processingTimeData ?? {}
  const processingTimeTrendData = dataClientPortalInternal?.processingTimeTrend
  const inquiryDateTrendData = dataClientPortalInternal?.inquiryTimeTrend
  const portalOption = dataClientPortalInternal?.portalOption

  const estimatedTime = processingTime?.estimatedTime
  const estimatedTimeUnit = processingTime?.unit
  const existsProcessingTimeData = !!processingTime?.estimatedTime
  const existsProcessingTimeTrendData = !!processingTimeTrendData && processingTimeTrendData.length > 0
  const existsInquiryDateTrendData = !!inquiryDateTrendData && inquiryDateTrendData.length > 0
  const noData = !existsProcessingTimeData && !existsProcessingTimeTrendData && !existsInquiryDateTrendData

  // Portal Options
  const {
    processingTime: showsProcessingTime,
    processingTimeTrend: showsProcessingTimeTrend,
    inquiryDateTrend: showsInquiryDateTrend,
  } = portalOption ?? {}

  return {
    noData,
    inquiryIcon,
    inquiryText,
    estimatedTime,
    estimatedTimeUnit,
    processingTimeTrendData,
    inquiryDateTrendData,
    applicationFilingDate,
    showsProcessingTime,
    showsProcessingTimeTrend,
    showsInquiryDateTrend,
    navigateToCaseDetail,
  }
}
